// TODO Remove workaround from this form and implement an optimal solution
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';
import { Form, TextInputMaskedForForms } from '@components/common';
import Actions, { thunks } from '@redux/app';
import formSchema from './formSchema';

class BankAccountVerificationForm extends Component {
	constructor(props) {
		super(props);
		// TODO Remove this warning once this component is optimized
		console.warn('BankAccountVerificationForm: This component is using react-jsonschema-form');
	}

	shouldComponentUpdate = ({ bankAccountId }) => {
		const lastProps = this.props;
		return (
			// Workaround Here: amountOne and amountTwo were removed from shouldComponentUpdate validation
			// so the Form doesn't get updated everytime the state of those fields change
			// TODO Add amountOne and amountTwo to shouldComponentUpdate validation
			!isEqual(lastProps.bankAccountId, bankAccountId)
		);
	}

	componentWillUnmount = () => {
		const { resetForm } = this.props;
		resetForm('bankAccountVerification');
	}

	handleFormChange = ({ formData : { amountOne, amountTwo } }) => {
		const { setField } = this.props;
		setField('bankAccountVerification', 'amountOne', amountOne);
		setField('bankAccountVerification', 'amountTwo', amountTwo);
	};

	handleFormCancel = () => {
		const { resetForm } = this.props;
		resetForm('bankAccountVerification');
	}

	handleFormSubmit = () => {
		const {
			bankAccountId, amountOne, amountTwo, dispatch,
		} = this.props;

		const integerAmounts = {
			amountOne : Math.trunc(parseFloat(amountOne) * 100),
			amountTwo : Math.trunc(parseFloat(amountTwo) * 100),
		};

		dispatch(thunks.verifyBankAccount({ bankAccountId, ...integerAmounts }));
	}

	render() {
		const { amountOne, amountTwo } = this.props;
		return (
			<Fragment>
				<Form
					keyName="bankAccountVerificationForm"
					formSchema={formSchema}
					formData={{ amountOne, amountTwo }}
					onSubmit={this.handleFormSubmit}
					onChange={this.handleFormChange}
					widgets={{
						textInputMaskedForForms : TextInputMaskedForForms,
					}}
					setRefValue={(ref) => { this.form = ref; }}
				>
					<div>

						<div className="text-right">
							<Button
								onClick={this.handleFormCancel}
								className="btn btn-default margin-right-15"
							>
								Cancel
							</Button>
							<Button
								type="submit"
								className="btn btn-primary"
							>
								Verify
							</Button>
						</div>
					</div>
				</Form>
			</Fragment>
		);
	}
}

const mapStateToProps = ({ app : { bankAccountVerification : { bankAccountId, amountOne, amountTwo } } }) => ({
	bankAccountId,
	amountOne,
	amountTwo,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	setField  : bindActionCreators(Actions, dispatch).setFormField,
	resetForm : bindActionCreators(Actions, dispatch).resetForm,
});

BankAccountVerificationForm.propTypes = {
	amountOne : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	amountTwo : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	bankAccountId : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	dispatch  : PropTypes.func.isRequired,
	resetForm : PropTypes.func.isRequired,
	setField  : PropTypes.func.isRequired,
};

BankAccountVerificationForm.defaultProps = {
	amountOne     : '',
	amountTwo     : '',
	bankAccountId : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(BankAccountVerificationForm);
